module.exports = __webpack_public_path__ + "img/NO-SLEEP-GANG.dc5b833d.gif";